module.exports = __webpack_public_path__ + "static/media/Orangevale (2).1df8f897.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-la/Orangevale (2).jpg
// module id = 416
// module chunks = 0